/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import RANGE_NUMBER_STEP from "../layer_style_editor/RANGE_NUMBER_STEP";
import COLOR_SCHEME_EDITOR from "../layer_style_editor/COLOR_SCHEME_EDITOR";

/*REDUX*/
import { importLayer } from "../../App/actions/layerNewActions";
import {
  set_value_toolbox,
  status_toolbox,
} from "../../App/actions/toolboxActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import ProgressBarButton from "../reuseable/ProgressBarButton";
import { post_activities } from "../../App/actions/activities";

/*CONST*/

class GRID_STEP_3 extends Component {
  state = {
    modal_save: false,
  };

  on_save = () => {
    this.props.set_value_toolbox({
      key: "features_grid_raw",
      value: [],
    });
    this.props.set_value_toolbox({
      key: "features_grid",
      value: [],
    });
    this.props.status_toolbox();

    let { style_parameter, paint_object_edited } = this.props.properties;
    const { toolbox_grid_object, features_grid, mode_toolbox } = this.props.toolbox;
    const { geo_project } = this.props.project;
    const { domain } = this.props.auth;
    const { geo_layer_list } = this.props.layer;

    const { layer_point_id, layer_polygon_id } = toolbox_grid_object;
    const name_polygon =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_polygon_id)
        ?.geo_layer?.name || "Polygon";
    const name_point =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_point_id)
        ?.geo_layer?.name || "Point";
    const field_key = "ALL_POI_COUNT";

    paint_object_edited = {
      ...paint_object_edited,
      //line bawaan terpisah
      "line-color": "#000000",
      "line-width": 1,
      "line-opacity": 1,
      "line-dasharray": [],
      "line-gap-width": 0,
    };
    style_parameter.paint_object = paint_object_edited;
    style_parameter.key = field_key;
    style_parameter.field_key = field_key;
    const fields = [
      {
        uuid: field_key,
        key: field_key,
        name: field_key,
        description: "",
        unit: "",
        type: "number",
        isHighlight: false,
        isRequired: true,
        isHide: false,
        isStyle: false,
      },
    ];
    const geojson = {
      type: "FeatureCollection",
      features: features_grid,
    };
    const style_array = [style_parameter];
    const body = {
      name: `[TOOLBOX GRID] ${name_point} & ${name_polygon}`,
      description: "",
      type: "Polygon",
      user_id: this?.props?.auth?.user?._id,
      folder: "",
      geo_project_id: geo_project?._id,
      fields,
      geojson,
      status: "toolbox_grid",
      domain,
      style_array,
      default_style_key: field_key,
      is_cluster: false,
      is_use_new_style: true,
      is_show_and_fly: false,
      toolbox_grid_object,
    };
    this.props.importLayer(body, false);

    const toolbox_type = mode_toolbox.replace("features_", "").replace("scoring_", "");
    if (this.props.toolbox.start_time) this.props.post_activities({ action: `toolbox-${toolbox_type}-save`, duration_ms: new Date() - this.props.toolbox.start_time });
  };

  toggle_save = () => {
    this.setState({ modal_save: !this.state.modal_save });
  };

  on_toggle_and_save = () => {
    this.toggle_save();
    this.on_save();
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const { modal_save } = this.state;

    //global props
    const {
      toolbox_grid_object,
      // current_grid_group, 
      // total_grid_group 
    } =
      this.props.toolbox;
    const { loading_item_array } = this.props.loading_reducer;

    //content
    const { grid_counts, grid_width_meters } = toolbox_grid_object;
    const modal_save_content = modal_save && (
      <Modal modalSize="small" isOpen={modal_save} onClose={this.toggle_save}>
        <div className="box-body" id="box-body">
          {loading_item_array.includes("importLayer")
            ? "Menyimpan hasil toolbox..."
            : "Tersimpan"}
        </div>
      </Modal>
    );

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          margin: "20px",
        }}
      >
        {modal_save_content}
        {/* {current_grid_group >= total_grid_group ? ( */}
        <div style={{ display: "flex", gap: "10px", flexDirection: "column" }}>
          <div style={{ backgroundColor: "#80B5201A", borderRadius: "10px", padding: "8px 16px", width: "fit-content" }}>
            <h2 style={{ color: "#006C3D", fontSize: "12px", fontWeight: 600 }}>{dict?.["Result"]?.[language]}</h2>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
            <div style={{ width: "50%", border: "0.5px solid #ABABAB4D", backgroundColor: "#FAFAFA", borderRadius: "10px", display: "flex", flexDirection: "column", gap: "5px", justifyContent: "center", padding: "8px 16px" }}>
              <p style={{ fontSize: "12px" }}>
                {dict?.["Number of grids"]?.[language]}
              </p>
              <p style={{ fontSize: "24px", fontWeight: 700 }}>{grid_counts}</p>
            </div>
            <div style={{ width: "50%", border: "0.5px solid #ABABAB4D", backgroundColor: "#FAFAFA", borderRadius: "10px", display: "flex", flexDirection: "column", gap: "5px", justifyContent: "center", padding: "8px 16px" }}>
              <p style={{ fontSize: "12px" }}>
                {dict?.["Grid size (meters)"]?.[language]}
              </p>
              <p style={{ fontSize: "24px", fontWeight: 700 }}>{grid_width_meters}</p>
            </div>
          </div>

          <section className="container_light outline_transparent background_white">
            <COLOR_SCHEME_EDITOR />
            <hr />
            <RANGE_NUMBER_STEP />
          </section>
          <br />


          <ProgressBarButton
            name="point"
            onClick={this.on_toggle_and_save}
          >
            {dict?.["Save"]?.[language]}
          </ProgressBarButton>
        </div>
        {/* ) : (
          <div>
            <p className="text_medium">
              {dict?.["Run the grid tool first"]?.[language]}
            </p>
          </div>
        )} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  toolbox: state.toolbox,
  map: state.map,
  layer: state.layer,
  properties: state.properties,
  loading_reducer: state.loading_reducer,
  project: state.project,
});

export default connect(mapStateToProps, {
  importLayer,
  set_value_toolbox,
  status_toolbox,
  post_activities,
})(GRID_STEP_3);
